module.exports = __webpack_public_path__ + "media/img/features/front-page-thumb-df547076ab810249685c7e19e0f10a4e.png";